import React from 'react';
import CommonTermsPage, { WEBSITE, EMAIL, DIETA_NIEMOWLAKA_DATA } from './CommonTermsPage';

const termsSections = [
  {
    heading: '1. Postanowienia Ogólne',
    content: `Aplikacja „Dieta Niemowlaka” służy do wspomagania rodziców w procesie rozszerzania diety małych dzieci. Informacje zawarte w aplikacji mają charakter poglądowy i nie zastępują porady lekarza ani dietetyka. Aplikacja jest prowadzona przez ${DIETA_NIEMOWLAKA_DATA}.`,
  },
  {
    heading: '2. Odpowiedzialność',
    content: 'Każdy rodzic korzystający z aplikacji podejmuje decyzje dotyczące karmienia swojego dziecka na własną odpowiedzialność. Aplikacja nie ponosi odpowiedzialności za ewentualne skutki wynikające z zastosowania informacji zawartych w aplikacji.',
  },
  {
    heading: '3. Zasady Korzystania',
    content: 'Korzystanie z aplikacji jest dobrowolne i wymaga akceptacji niniejszych warunków. Aplikacja może być używana wyłącznie do celów osobistych, niezwiązanych z działalnością komercyjną.',
  },
  {
    heading: '4. Zmiany w Warunkach Użytkowania',
    content: `Zastrzegamy sobie prawo do wprowadzania zmian w niniejszych Warunkach Użytkowania. O wszelkich zmianach użytkownicy będą informowani poprzez stronę ${WEBSITE}. Zmiany wchodzą w życie w momencie ich opublikowania, chyba że określono inaczej.`,
  },
  {
    heading: '5. Polityka Prywatności',
    content: `Szczegółowe informacje dotyczące przetwarzania danych osobowych znajdują się w Polityce Prywatności dostępnej na stronie ${process.env.REACT_APP_ROOT_URL}/privacy.`,
  },
  {
    heading: '6. Kontakt',
    content: `W razie pytań prosimy o kontakt pod adresem: ${EMAIL}.`,
  },
];

const TermsOfService = () => {
  return <CommonTermsPage title="Warunki Użytkowania" sections={termsSections} />;
};

export default TermsOfService;